import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames'

const IconLogOutSVG = ({color, className, ...rest}) => {
    return (
        <svg {...rest} width="24" height="24" viewBox="0 0 24 24" fill="none"
             className={classNames(['svg-icon svg-logout', className])}>
            <path className="a" d="M0,0H24V24H0Z" fill="none"/>
            <path className="b" fill={color}
                  d="M10.79,16.29a1,1,0,0,0,1.41,0l3.59-3.59a1,1,0,0,0,0-1.41L12.2,7.7a1,1,0,0,0-1.41,1.41L12.67,11H4a1,1,0,0,0,0,2h8.67l-1.88,1.88A1,1,0,0,0,10.79,16.29ZM19,3H5A2,2,0,0,0,3,5V8A1,1,0,0,0,5,8V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1V18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V16a1,1,0,0,0-2,0v3a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Z"/>
        </svg>

    );
};

IconLogOutSVG.propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

IconLogOutSVG.defaultProps = {
    color: '#32CCCC',
    className: '',
};

export default IconLogOutSVG;